module.exports = __webpack_public_path__ + "img/20180815_145911_033.921a5657.jpg";